export const dataWater = {
  labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  datasets: [
    {
      label: 'Water lever',
      data: [] as string[] | number[] | null[],
      fill: true,
      backgroundColor: 'rgba(75,192,192,0.2)',
      borderColor: 'red',
    },
  ],
};

export const configWater = {
  type: 'line',
  data: dataWater,
  options: {
    title: {
      display: false,
      text: '',
    },
    scales: {
      xAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: '年',
          },
          ticks: {
            max: 100,
            min: 0,
          },
        },
      ],
      yAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: '水位 (cm)',
          },
          ticks: {
            max: 300,
            min: -200,
          },
        },
      ],
    },
    tooltips: {
      mode: 'nearest',
      intersect: false,
    },
    hover: {
      mode: 'nearest',
      intersect: false,
    },
  },
};
